import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CMSModule } from 'ish-shared/cms/cms.module';
import { SharedModule } from 'ish-shared/shared.module';
import { ShellModule } from 'ish-shell/shell.module';

import { BasketPageComponent } from './basket-page.component';
import { ShoppingBasketEmptyComponent } from './shopping-basket-empty/shopping-basket-empty.component';
import { ShoppingBasketPaymentComponent } from './shopping-basket-payment/shopping-basket-payment.component';
import { ShoppingBasketComponent } from './shopping-basket/shopping-basket.component';
import { BasketOrderRecurrenceEditComponent } from './basket-order-recurrence-edit/basket-order-recurrence-edit.component';

const basketPageRoutes: Routes = [{ path: '', component: BasketPageComponent }];

@NgModule({
  imports: [RouterModule.forChild(basketPageRoutes), CMSModule, SharedModule, ShellModule],
  declarations: [
    BasketPageComponent,
    ShoppingBasketComponent,
    ShoppingBasketEmptyComponent,
    ShoppingBasketPaymentComponent,
    BasketOrderRecurrenceEditComponent,
  ],
})
export class BasketPageModule {}
